var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 195,
    viewBox: "0 0 255 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.82 149.85C49.3143 155.538 50.2945 159.107 50.7604 160.556C51.4593 162.73 53.535 167.798 57.3796 170.546C61.2241 173.293 66.8498 173.827 70.9994 172.499C75.1491 171.171 79.7311 167.779 81.3342 166.321C82.9374 164.863 82.4101 163.121 82.0225 162.472C81.8344 162.157 81.5858 162.663 80.4868 162.688C80.0761 162.697 79.2649 162.767 79.0785 162.544C78.8921 162.321 78.4632 161.333 79.1368 160.075C79.5858 159.237 80.1498 158.917 80.8286 159.116C69.5072 161.977 71.7001 162.229 87.4074 159.872C110.968 156.338 123.9 126.135 136.392 109.442C148.938 92.6766 156.585 77.9297 159.334 65.201C159.155 57.8937 156.913 53.3419 152.61 51.5455C148.307 49.7491 143.135 51.5523 137.094 56.955C126.671 76.3939 112.936 90.5215 95.889 99.3379C78.8424 108.154 67.0575 114.792 60.5343 119.251C56.921 120.899 54.2317 122.554 52.4663 124.217C50.701 125.881 49.0255 129.258 47.4398 134.349L47.82 149.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.82 149.85C49.3143 155.538 50.2945 159.107 50.7604 160.556C51.4593 162.73 53.535 167.798 57.3796 170.546C61.2241 173.293 66.8498 173.827 70.9994 172.499C75.1491 171.171 79.7311 167.779 81.3342 166.321C82.9374 164.863 82.4101 163.121 82.0225 162.472C81.8344 162.157 81.5858 162.663 80.4868 162.688C80.0761 162.697 79.2649 162.767 79.0785 162.544C78.8921 162.321 78.4632 161.333 79.1368 160.075C79.5858 159.237 80.1498 158.917 80.8286 159.116C69.5072 161.977 71.7001 162.229 87.4074 159.872C110.968 156.338 123.9 126.135 136.392 109.442C148.938 92.6766 156.585 77.9297 159.334 65.201C159.155 57.8937 156.913 53.3419 152.61 51.5455C148.307 49.7491 143.135 51.5523 137.094 56.955C126.671 76.3939 112.936 90.5215 95.889 99.3379C78.8424 108.154 67.0575 114.792 60.5343 119.251C56.921 120.899 54.2317 122.554 52.4663 124.217C50.701 125.881 49.0255 129.258 47.4398 134.349L47.82 149.85Z",
    stroke: "#292929",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6731 152.944C72.8116 157.204 73.7627 160.178 73.5263 161.867C72.9234 166.173 76.157 167.608 78.6639 167.057C84.6995 165.729 82.3116 150.611 81.946 150.074",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M70.6731 152.944C72.8116 157.204 73.7627 160.178 73.5263 161.867C72.9234 166.173 76.157 167.608 78.6639 167.057C84.6995 165.729 82.3116 150.611 81.946 150.074",
    stroke: "#292929",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9233 145.7C50.0604 148.956 46.5483 151.495 43.387 153.318C38.6451 156.052 36.802 156.831 32.1027 157.136C27.4033 157.442 26.5034 153.931 25.5241 152.419C24.8712 151.411 25.3152 150.095 26.856 148.473C32.4749 144.84 36.7903 141.794 39.8021 139.334C42.066 137.484 45.0227 134.714 47.1007 131.969C49.1695 129.236 50.3595 126.525 52.6623 126.179",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M53.9233 145.7C50.0604 148.956 46.5483 151.495 43.387 153.318C38.6451 156.052 36.802 156.831 32.1027 157.136C27.4033 157.442 26.5034 153.931 25.5241 152.419C24.8712 151.411 25.3152 150.095 26.856 148.473C32.4749 144.84 36.7903 141.794 39.8021 139.334C42.066 137.484 45.0227 134.714 47.1007 131.969C49.1695 129.236 50.3595 126.525 52.6623 126.179",
    stroke: "#292929",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.728 195.885C106.642 184.429 100.547 169.602 98.4429 151.403C95.2873 124.104 124.746 93.9113 129.754 81.2304C134.762 68.5496 135.815 59.3885 137.779 55.5452C141.264 48.7256 143.812 44.3105 145.423 42.2998C152.622 33.0578 158.615 28.4368 163.401 28.4368C170.579 28.4368 170.579 23.3925 186.49 28.4368C202.401 33.4812 237.321 69.3066 249.198 114.595C257.116 144.787 253.861 171.884 239.433 195.885H116.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M116.728 195.885C106.642 184.429 100.547 169.602 98.4429 151.403C95.2873 124.104 124.746 93.9113 129.754 81.2304C134.762 68.5496 135.815 59.3885 137.779 55.5452C141.264 48.7256 143.812 44.3105 145.423 42.2998C152.622 33.0578 158.615 28.4368 163.401 28.4368C170.579 28.4368 170.579 23.3925 186.49 28.4368C202.401 33.4812 237.321 69.3066 249.198 114.595C257.116 144.787 253.861 171.884 239.433 195.885H116.728Z",
    stroke: "#353535",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.779 195.885C190.193 185.995 185.713 177.693 184.339 170.978C182.965 164.263 183.547 153.514 186.084 138.733C189.989 123.727 192.389 111.888 193.284 103.216C194.179 94.5439 194.179 83.1227 193.284 68.9522C189.548 55.8431 191.046 47.7543 197.779 44.6858C204.511 41.6173 212.778 45.7016 222.58 56.9387C238.588 81.0397 248.433 103.727 252.113 125.002C255.793 146.277 252.072 169.904 240.949 195.885H197.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M197.779 195.885C190.193 185.995 185.713 177.693 184.339 170.978C182.965 164.263 183.547 153.514 186.084 138.733C189.989 123.727 192.389 111.888 193.284 103.216C194.179 94.5439 194.179 83.1227 193.284 68.9522C189.548 55.8431 191.046 47.7543 197.779 44.6858C204.511 41.6173 212.778 45.7016 222.58 56.9387C238.588 81.0397 248.433 103.727 252.113 125.002C255.793 146.277 252.072 169.904 240.949 195.885H197.779Z",
    stroke: "#353535",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.637 84.1389C244.565 98.2947 249.161 111.916 251.425 125.002C252.52 131.333 252.96 137.872 252.744 144.62C234.118 139.895 221.34 132.759 214.41 123.213C207.498 108.508 215.24 95.4835 237.637 84.1389Z",
    fill: "#FBFBFB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.758 14.5041C177.917 22.3936 173.837 35.887 162.654 44.6167C151.47 53.3463 137.39 54.0284 131.232 46.139C125.073 38.2495 129.153 24.756 140.336 16.0264C151.52 7.29677 165.6 6.61463 171.758 14.5041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M171.758 14.5041C177.917 22.3936 173.837 35.887 162.654 44.6167C151.47 53.3463 137.39 54.0284 131.232 46.139C125.073 38.2495 129.153 24.756 140.336 16.0264C151.52 7.29677 165.6 6.61463 171.758 14.5041Z",
    stroke: "#353535",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M132.986 47.1526C136.16 46.9549 138.42 46.6493 139.765 46.2356C141.111 45.822 142.87 44.9386 145.04 43.5855",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.267 38.9285C146.754 38.4174 148.427 39.3595 149.002 41.0309C149.577 42.7023 148.836 44.4743 147.35 44.9854C145.864 45.4965 144.19 44.5544 143.616 42.883C143.041 41.2116 143.781 39.4396 145.267 38.9285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M145.267 38.9285C146.754 38.4174 148.427 39.3595 149.002 41.0309C149.577 42.7023 148.836 44.4743 147.35 44.9854C145.864 45.4965 144.19 44.5544 143.616 42.883C143.041 41.2116 143.781 39.4396 145.267 38.9285Z",
    stroke: "black",
    strokeMiterlimit: 1,
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.369 42.1946C129.607 43.0179 129.95 44.0128 131.018 45.6229C131.64 46.5597 132.626 47.7046 133.421 48.2775C133.715 46.6426 133.538 45.3517 132.89 44.405C132.241 43.4582 131.068 42.7214 129.369 42.1946Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.02344 137.922L24.7871 119.627C24.7871 136.671 24.7871 149.564 24.7871 158.304C24.7871 167.045 24.7871 178.602 24.7871 192.977L2.02344 178.09V137.922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M2.02344 137.922L24.7871 119.627C24.7871 136.671 24.7871 149.564 24.7871 158.304C24.7871 167.045 24.7871 178.602 24.7871 192.977L2.02344 178.09V137.922Z",
    stroke: "#444444",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6633 188.745L21.6503 152.578C21.6502 152.299 21.4236 152.072 21.1442 152.072C20.944 152.072 20.7626 152.191 20.6817 152.374L8.42118 180.133L21.6633 188.745Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30078 181.543L7.92238 178.135L12.5644 180.438L2.44931 181.676L2.30078 181.543Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M2.30078 181.543L7.92238 178.135L12.5644 180.438L2.44931 181.676L2.30078 181.543Z",
    stroke: "#E6E6E6",
    strokeMiterlimit: 1,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.02278 181.755L0.205078 192.753V195L6.87161 181.755H2.02278Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M2.02278 181.755L0.205078 192.753V195L6.87161 181.755H2.02278Z",
    stroke: "#E6E6E6",
    strokeMiterlimit: 1,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 195.496L6.58325 183.875L12.1672 180.906L2.856 181.676L6.11575 183.875L3.539 187.203L0.205739 192.417L0 195.496Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M0 195.496L6.58325 183.875L12.1672 180.906L2.85601 181.676L6.11575 183.875L3.539 187.203L0.205739 192.417L0 195.496Z",
    stroke: "#CFCFCF",
    strokeMiterlimit: 1,
    strokeLinecap: "square"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.409ff0b4146ef81cb7da18c770e52450.svg";
export { ForwardRef as ReactComponent };